import { c as _c } from "react/compiler-runtime";
import React from "react";
import UniversalButton from "@/components/common/UniversalButton";
import styles from "@/features/partner-with-us/BusinessDetailsForm/main.module.css";
import TermsText from "./TermsText";
interface SubmitSectionProps {
  isLoading: boolean;
}
const SubmitSection: React.FC<SubmitSectionProps> = t0 => {
  const $ = _c(6);
  const {
    isLoading
  } = t0;
  const t1 = isLoading ? "Processing..." : "Proceed";
  let t2;
  if ($[0] !== isLoading || $[1] !== t1) {
    t2 = <UniversalButton text={t1} type="submit" variant="custom" classNames={styles.submitButton} disabled={isLoading} />;
    $[0] = isLoading;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <TermsText />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <div className={styles.submitSection}>{t2}{t3}</div>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default SubmitSection;